import PropTypes from 'prop-types'
import { Component } from 'react'

import eases from './eases'

//https://github.com/javierbyte/react-number-easing

class NumberAnimation extends Component<any, any> {
  static propTypes = {
    value: PropTypes.number.isRequired,
    speed: PropTypes.number,
    ease: PropTypes.oneOf(Object.keys(eases)),
    delayValue: PropTypes.number,
    className: PropTypes.string
  }

  static defaultProps = {
    speed: 500,
    ease: 'quint-in',
    delayValue: 0,
    className: ''
  }

  delayTimeout: any

  state = { displayNumber: '', previusValue: 0, displayValue: undefined }
  timeout: number = null!
  startAnimationTime: number = null!

  getInitialState() {
    const value = this.props.value

    return {
      previousValue: value,
      displayValue: value
    }
  }

  componentDidMount() {
    const { value } = this.props
    this.setState({ previousValue: value, displayValue: value })
  }

  componentDidUpdate(prevProps: any) {
    const { value, delayValue } = this.props

    if (prevProps.value === value) return

    this.setState({
      previousValue: this.state.displayValue
    })

    if (delayValue && delayValue > 0) {
      clearTimeout(this.timeout)
      clearTimeout(this.delayTimeout)
      this.delayTimeout = setTimeout(() => {
        this.startAnimationTime = Date.now()
        this.updateNumber()
      }, delayValue)
    } else {
      clearTimeout(this.timeout)
      clearTimeout(this.delayTimeout)
      const now = Date.now()
      const elapsedTime = Math.min(this.props.speed, now - this.startAnimationTime)
      // @ts-expect-error
      const progress = eases[this.props.ease](elapsedTime / this.props.speed)
      if (progress > 0.5) {
        this.startAnimationTime = Date.now()
      }

      this.updateNumber()
    }
  }

  shouldComponentUpdate(nextProps: any, nextState: any) {
    return nextState.displayValue !== this.state.displayValue || nextProps.value !== this.props.value
  }

  updateNumber = () => {
    const { value } = this.props

    const now = Date.now()
    const elapsedTime = Math.min(this.props.speed, now - this.startAnimationTime)
    // @ts-expect-error
    const progress = eases[this.props.ease](elapsedTime / this.props.speed)

    // @ts-expect-error
    const currentDisplayValue = Math.round((value - this.state.previousValue) * progress + this.state.previousValue)

    this.setState({
      displayValue: currentDisplayValue
    })

    if (elapsedTime < this.props.speed) {
      this.timeout = setTimeout(this.updateNumber, 16) as any as number
    } else {
      this.setState({
        previousValue: value
      })
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
    clearTimeout(this.delayTimeout)
  }

  render() {
    const { className } = this.props
    const { displayValue } = this.state

    return <span className={className}>{displayValue}</span>
  }
}

export default NumberAnimation
